import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';

# Create or Edit Role

## Name

The name for the Role.

## Description

An explanation of the role and permissions given.

## Permissions

<v-icon>mdi-checkbox-marked</v-icon> Adds a permission.

<v-icon>mdi-checkbox-blank-outline</v-icon> Removes a permission.

## Saving

Click <ExampleSaveButton color='white' text='CREATE' /> or <ExampleSaveButton color='white' /> to create/save your changes.

To cancel click <ExampleCloseButton /> (top right).

## Deleting

{/* Editor Note */}

{/* The icon in Edit Role is actually a mdi-content-save */}

In Edit Role, click <ExampleDeleteButton color='white'/> (bottom left). A confirmation box will appear, click OK to delete, or Cancel to cancel.
